import React from "react"

import { connect, currentPage } from "scrivito"

import { ProtectedRoute } from "./ProtectedRoute"

export const ScrivitoRouteGuard = React.memo(
  connect(({ children }: { children: React.ReactNode }) => {
    const page = currentPage()

    if (page && page.get("isLoginRequired")) {
      return <ProtectedRoute key={page.id()}>{children}</ProtectedRoute>
    }

    return children as React.JSX.Element
  })
)
